import { render, staticRenderFns } from "./NewMyAccount.vue?vue&type=template&id=15e40e4d&scoped=true"
import script from "./NewMyAccount.vue?vue&type=script&lang=js"
export * from "./NewMyAccount.vue?vue&type=script&lang=js"
import style0 from "./NewMyAccount.vue?vue&type=style&index=0&id=15e40e4d&prod&scoped=true&lang=css"
import style1 from "./NewMyAccount.vue?vue&type=style&index=1&id=15e40e4d&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15e40e4d",
  null
  
)

export default component.exports